export default __webpack_public_path__ + "static/swim-0420cb936858dafd7294655a7b74947a.jpg";